import React, { Component } from 'react';
import { connect } from 'react-redux';

import TimePicker from 'material-ui-pickers/TimePicker';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

// pick utils
import moment from 'moment';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import 'moment/locale/es';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import orange from '@material-ui/core/colors/orange';

moment.locale('es');

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#f99e60'
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      }
    },
    MuiPickersDay: {
      day: {
        //color: orange.A700,
      },
      selected: {
        backgroundColor: '#f99e60'
      },
      current: {
        color: orange['900']
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#f99e60'
      }
    },
    MuiModal:{
        root: {
            zIndex: 2001,
        }
    }
  }
});

class TimeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: props.date == "" ? null : props.date,
      style: {
        fontWeight: 'normal',
        //background: '#616161',
        borderRadius: '4px',
        height: 'auto',
        width: '100%'
      }
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if(nextProps.date!="") {
      var parser = d3.time.format.utc("%Y-%m-%d %H:%M:%S").parse;
      var date = parser(nextProps.date);
      date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
      const rest = moment(date.getTime());
      this.state.selectedDate = rest;
    }
    else if(nextProps.date=="") {
      this.state.selectedDate = null;
    }
  }
  
  handleDateChange = date => {
    if(this.props.onChange) {
      this.props.onChange({target: {
        value:date.format('HH:mm'),
        id: this.props.id,
        dataset: {update: this.props.dataUpdate, time: true},
      }});
    }
    this.setState({ selectedDate: date });
  };

  handleClear = value => {
    if(this.props.onChange) {
      this.props.onChange({target: {
        value:null,
        id: this.props.id,
        dataset: {update: this.props.dataUpdate, date: true},
      }});
    }
    this.setState({ selectedDate: null });
  };
  
  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={'es'} moment={moment}>
        <MuiThemeProvider theme={materialTheme}>
          <div className="form-date-picker form-time-picker box-clear">
            <TimePicker
              id={this.props.id}
              data-style="date_picker_form"
              value={this.state.selectedDate}
              onChange={this.handleDateChange}
              style={this.state.style}
              clearable={false}
              autoOk={true}
              ampm={false}
              disabled={this.props.disabled}
              placeholder={this.props.placeholder ? this.props.placeholder : ""}
            />
            {!this.props.hideClear && this.state.selectedDate !== '' 
            && this.state.selectedDate !== null && (
              <div className="box-clear-button">
                <button onClick={this.handleClear}>
                  <i className="fas fa-times-circle" />
                </button>
              </div>
            )}
          </div>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}

export default TimeInput;



// WEBPACK FOOTER //
// ./source/client/components/common/extended_property/timeInput.jsx